import BGS1 from '../../assets/images/services/service-s-1-1.png'
import React, { useState, useEffect }   from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

export default function FMsidebar() {

    const [link, setPost] = useState()
    useEffect(() => {
        axios.get('/financialmarket')
            .then((response) => {
                let postData = response.data
                console.log(postData);
                setPost(postData)
            })
            .catch((error) => console.log(error))
    }, [])


  return (
    <div className="service-sidebar">
        <div className="service-sidebar__item service-sidebar__item--menu">
            <ul className="service-sidebar__menu">
            {
                      link ? link.map((l, index) => (
                                    <>
              <li key={l.id}>
              <Link to={`${l.link}`}>{l.title}</Link>
              </li>
              </>
                                    )) : <p>loading...</p>
                                }
                  
             </ul>
           </div>
        {/* <div className="service-sidebar__item service-sidebar__item--contact">
       
        <div className="service-sidebar__contact">
            <div className="service-sidebar__icon">
                <i className="icon-phone-ringing"></i>
            </div>
            <h3 className="service-sidebar__title">Any Query related to Financial Market?</h3>
            <hr className="service-sidebar__separator" />
            <p className="service-sidebar__tagline">Talk to an expert</p>
            <Link to="tel:+250-788823949" className="service-sidebar__phone" >+250-788823949</Link>
            <p className="service-sidebar__phone">fmd@bnr.rw</p>
            </div>
        </div> */}
    </div>
  )
}
